import { css } from '@linaria/core';
export const starBadge = "odules__Home__Badge__badge_styles_ts-starBadge-sj8osdo";
export const greenBadge = "odules__Home__Badge__badge_styles_ts-greenBadge-gegjzx1";
export const blueBadge = "odules__Home__Badge__badge_styles_ts-blueBadge-b7prg2a";

require("./badge.styles.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./badge.styles.ts");